"use client";

import { Star } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TestimonialsPreview() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const testimonials = [{
    id: 1,
    name: "James W.",
    rating: 5,
    quote: "\"MT4 Drone Service thermal imaging saved us thousands on our roof inspection. The data was incredibly detailed and delivered same-day.\""
  }, {
    id: 2,
    name: "David T.",
    rating: 5,
    quote: "\"Their DJI Matrice 4t captured our entire construction site in one flight. Real-time monitoring made all the difference.\""
  }, {
    id: 3,
    name: "Emily C.",
    rating: 5,
    quote: "\"Professional, insured, and efficient. The additional monitor allowed us to view footage on-site. Highly recommend for any aerial survey needs.\""
  }];
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section className="bg-background py-16 px-6">
      <div className="mx-auto max-w-4xl">
        <div className="mb-12 text-center">
          <h2 className="text-3xl font-bold text-foreground mb-3">What Our Clients Say</h2>
          <p className="text-muted-foreground text-lg">Trusted by businesses across Central Texas and the DFW Metroplex</p>
        </div>

        <div className="flex flex-col gap-6">
          {testimonials.map((testimonial, i) => <div key={testimonial.id} ref={refs[i]} data-index={i} className="transition-all duration-150 ease-[cubic-bezier(0.4,0,0.2,1)]" style={{
          opacity: visibilities[i] ? 1 : 0,
          transform: visibilities[i] ? "translateY(0)" : "translateY(20px)",
          transitionDelay: visibilities[i] ? `${i * 100}ms` : "0ms"
        }}>
              <Card className="group hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
                <CardContent className="flex flex-col gap-4">
                  <div className="flex items-center justify-between">
                    <h3 className="font-semibold text-lg text-foreground">{testimonial.name}</h3>
                    <div className="flex gap-0.5">
                      {Array.from({
                    length: testimonial.rating
                  }).map((_, starIndex) => <Star key={starIndex} className="h-5 w-5 fill-accent text-accent" />)}
                    </div>
                  </div>
                  <p className="text-foreground/80 leading-relaxed transition-transform duration-100 ease-[var(--ease-smooth)] group-hover:scale-[1.01]">
                    "{testimonial.quote}"
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}